import React, { useEffect, useState } from "react";
import { Col, Modal, Row, Table } from "react-bootstrap";
import { useSelector } from "react-redux";
import { isEmpty } from "../Actions/commonFunction";
import { IoMdClose } from "react-icons/io";
import Scorecard from "./Scorecard";


function Scoreintermodal({totalscore,onDismiss}) {

    const [scoremodal, setScoremodal] = useState(true);
console.log("totalscore",totalscore);


    return (
    <div>

         <Modal
        show={scoremodal}
        className="scoremodal"
        size="xl"
        aria-labelledby="contained-modal-title-vcenter"
        centered>
        {/* <Modal.Header closeButton onClick={() => onDismiss()}></Modal.Header> */}
        <Modal.Body className="p-0">
           
                    <div className="interpretation pt-3 px-3 pb-3">
                         <div className="text-end px-2 px-sm-4 mb-2"><IoMdClose className="cursor-pointer" fontSize={25} onClick={() => onDismiss()}/></div>   
                    <h4 className="text-center pb-3 fw-600">
                      SOC Interpretation of Score
                    </h4>
                  <Scorecard type="interpretation"  totalscore={totalscore}/>
                  </div>
 
        </Modal.Body>
         </Modal>

    </div>
      )

}


export default Scoreintermodal;